import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { CarouselModule, ModalModule } from 'ngx-foundation';
import { AboutComponent } from './components/about/about.component';
import { GameComponent } from './components/game/game.component';
import { HomeComponent } from './components/home/home.component';
import { ProductComponent } from './components/product/product.component';
import { ResultComponent } from './components/result/result.component';
import { StartComponent } from './components/start/start.component';
import { GameOverviewComponent } from './game-overview.component';
import { GameRoutingModule } from './game-routing.module';

@NgModule({
  declarations: [
    GameOverviewComponent,
    HomeComponent,
    AboutComponent,
    ProductComponent,
    StartComponent,
    GameComponent,
    ResultComponent,
  ],
  imports: [
    CommonModule,
    GameRoutingModule,
    RoundProgressModule,
    ModalModule,
    CarouselModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [],
})
export class GameModule {}
